import { Button } from "primereact/button";
import type { PolygonSelectionSummary } from "./polygon-selection";

interface Props {
  selection: PolygonSelectionSummary | null;
  missingGPS: number;
  busy: boolean;
  canViewMissingGPS: boolean;
  onViewMissingGPS: () => void;
  onAssign: () => void;
  ready?: boolean;
}

const inr = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 });

export default function PolygonSelectionPanel({ selection, missingGPS, busy, canViewMissingGPS, onViewMissingGPS, onAssign, ready = false }: Props) {
  return <section className="smart-map-selection" aria-label="Boundary selection" aria-busy={busy}>
    <div className="smart-map-selection-details" aria-live="polite" aria-atomic="true">
      {selection ? <>
        <dl className="smart-map-selection-metrics">
          <div><dt>Orders selected</dt><dd>{selection.orderCount}</dd></div>
          <div><dt>Total value (before GST)</dt><dd>{inr.format(selection.totalValue)}</dd></div>
          <div><dt>Unique customers</dt><dd>{selection.customerCount ?? "—"}</dd></div>
          <div><dt>Unique addresses</dt><dd>{selection.addressCount ?? "—"}</dd></div>
        </dl>
        {selection.orderCount < 2 && <p className="smart-map-selection-note">Select at least 2 unassigned orders to prepare a route.</p>}
        {(selection.customerCount === null || selection.addressCount === null) &&
          <p className="smart-map-selection-note">Some customer or address information is unavailable.</p>}
      </> : <p className="smart-map-selection-note">Draw a polygon to review unassigned orders.</p>}
    </div>
    <div className="smart-map-selection-gps">
      <span><strong>Missing GPS: {missingGPS}</strong><small>In filtered orders</small></span>
      <Button aria-label="View missing GPS" tooltip="View missing GPS" tooltipOptions={{ position: "top" }}
        icon="pi pi-map-marker" text size="small"
        disabled={!missingGPS || !canViewMissingGPS || busy} onClick={onViewMissingGPS} />
    </div>
    <Button label="Build route" icon="pi pi-directions" className="smart-map-selection-assign"
      loading={busy} disabled={!ready || !selection || selection.orderCount < 2 || busy} onClick={onAssign} />
  </section>;
}
